<template>
  <router-link :to="{ name: pathName }" class="tab">{{ title }}</router-link>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    pathName: String,
    title: String
  },
  setup() {
    return {}
  }
})
</script>

<style scoped></style>
